import { Injectable } from '@angular/core';
import {
	ComponentController,
	MessagingService,
} from '@lycoris-nubila/ngx-lycoris';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize, shareReplay } from 'rxjs/operators';

import {
	MfaEngageDialogState,
	MfaEngageDialogStore,
} from 'dialog/mfa-engage-dialog/mfa-engage-dialog.store';
import { UserApplicationPort } from 'user/port/user-application.port';

@Injectable()
export class MfaEngageDialogController extends ComponentController<MfaEngageDialogState> {
	public isSaving$: Observable<boolean>;

	constructor(
		store: MfaEngageDialogStore,
		private _messagingService: MessagingService,
		private _userApplicationPort: UserApplicationPort
	) {
		super(store);

		this._initObservables();
	}

	public validateMfaCode(mfaCode: string): Observable<void> {
		this.store.update({ isSaving: true });

		return this._userApplicationPort.validateUserMfa(mfaCode).pipe(
			catchError((e: Error) => {
				this._messagingService.publishMessage({
					summaryKey: 'presentation.app.common.dialog.mfa-engage.error.summary',
					detailKey: `presentation.app.common.dialog.mfa-engage.${e.message}`,
					severity: 'error',
				});
				return throwError(e);
			}),
			finalize(() => this.store.update({ isSaving: false }))
		);
	}

	private _initObservables() {
		this.isSaving$ = this.select('isSaving').pipe(
			shareReplay({ bufferSize: 1, refCount: true })
		);
	}
}
